// extracted by mini-css-extract-plugin
export default {"incodeMandatoryConsent":"IncodeMandatoryConsent__incodeMandatoryConsent-ibsz"};